import './bootstrap';
import '../css/app.css';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {createInertiaApp} from '@inertiajs/react';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import * as Sentry from "@sentry/react";
import {LaravelReactI18nProvider} from "laravel-react-i18n";
import {library} from "@fortawesome/fontawesome-svg-core";
import {fas} from "@fortawesome/free-solid-svg-icons";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

Sentry.init({dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC});

library.add(fas)

createInertiaApp({
    progress: {
        color: '#4B5563'
    },
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({el, App, props}) {
        createRoot(el).render(
            <LaravelReactI18nProvider
                locale={props.initialPage.props.locale}
                fallbackLocale={'en'}
                files={import.meta.glob('/lang/*.json')}
            >
                <App {...props} />
            </LaravelReactI18nProvider>
        )
    },
});
